var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"round-button",class:[_vm.color === 'red' ? 'red' : 'white'],on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }